import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import facebookIcon from "../../../assets/icons/facebook@3x.png";
import mailIcon from "../../../assets/icons/mail@3x.png";
import twitterIcon from "../../../assets/icons/twitter@3x.png";
import whatsappIcon from "../../../assets/icons/whatsapp@3x.png";
import { I18nContext } from "../../../providers/i18n";
import { clearResults } from "../../../utils/results-cache";
import Spinner from "../../common/Spinner";
import RadarChart from "../../RadarChart";
import Candidate from "../Candidate";
import "./styles.scss";

const ElectionResults = ({
  results,
  hash,
  onCandidateChosen,
  hasResults,
  onBackButton,
  districtLabel
}) => {
  const { t } = useContext(I18nContext);
  const SHARE_TEXT = encodeURIComponent(
    t("elections.candidatesMatch.shareText")
  );
  const FACEBOOK_LINK = encodeURIComponent("https://www.easyvote.ch/");
  const [showRestartModal, setShowRestartModal] = useState(false);

  const onCandidateClick = candidate => {
    onCandidateChosen(candidate);
  };

  const renderChart = () => {
    const { chartData } = results;
    const labels = chartData.map(it => it.label);
    const userData = chartData.map(it => ({ value: it.value }));

    return <RadarChart labels={labels} chart1={userData} />;
  };

  const handleShowRestartModal = () => {
    setShowRestartModal(true);
  };

  const handleNoClick = () => {
    setShowRestartModal(false);
  };

  const handleYesClick = () => {
    clearResults(hash);
    window.location.reload();
  };
  return (
    <div className="content">
      {results ? (
        <>
          <div className="results-screen-header">
            <button onClick={onBackButton}>
              {"« " + districtLabel}
            </button>
            <h3 className="results-title">
              {t("elections.candidatesMatch.resultsTitle")}
            </h3>
          </div>
          <div className="results-chart-title">
            {t("elections.candidatesMatch.chartTitle")}
          </div>
          {renderChart()}
          <p className="smartvote-website-link">
            © www.smartvote.ch / www.sotomo.ch
          </p>
          {hasResults && (
            <button
              className="show-results-button"
              onClick={handleShowRestartModal}
            >
              {t("elections.candidatesMatch.startOverButton")}
            </button>
          )}
          {results.candidates.map(candidate => (
            <Candidate
              onClick={onCandidateClick}
              key={candidate.id}
              candidate={candidate}
            />
          ))}
          <div className="results-social">
            <a
              href={`http://www.facebook.com/sharer/sharer.php?u=${FACEBOOK_LINK}`}
            >
              <img src={facebookIcon} alt="facebook" />
            </a>
            <a href={`https://twitter.com/intent/tweet?text=${SHARE_TEXT}`}>
              <img src={twitterIcon} alt="twitter" />
            </a>
            <a href={`whatsapp://send?text=${SHARE_TEXT}`}>
              <img src={whatsappIcon} alt="whatsapp" />
            </a>
            <a href={`mailto:?&body=${SHARE_TEXT}`}>
              <img src={mailIcon} alt="email" />
            </a>
          </div>
          {showRestartModal && (
            <div className={"modal-container"}>
              <div className="modal">
                <span className="modal__title">
                  {t("elections.candidatesMatch.restartTitle")}
                </span>
                <div className="modal__content">
                  <p className={"modal__description"}>
                    {t("elections.candidatesMatch.restartText")}
                  </p>
                  <div className="modal__buttons">
                    <button
                      onClick={handleNoClick}
                      className="modal__button no"
                    >
                      {t("no")}
                    </button>
                    <button
                      onClick={handleYesClick}
                      className="modal__button yes"
                    >
                      {t("yes")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100px",
            margin: "auto",
            height: "100%"
          }}
        >
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default withRouter(ElectionResults);
